export * from "./colonia";
export * from "./inactividad";
export * from "./session";
export * from "./turno";
export * from "./usuario";
export * from "./cliente";
export * from "./documentacion";
export * from "./ubicaciones";
export * from "./guia";
export * from "./ubicacion";
export * from "./cotizador";
export * from "./configsistema";
export * from "./contactocliente";
export * from "./identificacion";
export * from "./firmaremota";
export * from "./entregaocurre";
export * from "./sucursal";
export * from "./logistica";
export * from "./cajaruta";
export * from "./user";
export * from "./camion";
export * from "./viajeruta";
export * from "./cargadescarga";
export * from "./catalogossat";
export * from "./factura";
export * from "./matrizdistancias";
export * from "./facturacionguia";
export * from "./rutaead";
export * from "./viajeead";
export * from "./cargadescargaead";
export * from "./corteventa";
export * from "./viajeapp";
export * from "./cobranzasemanal";
export * from "./cortecaja";
export * from "./cortediario";
export * from "./contabilidad";
export * from "./recolecciondomicilio";
export * from "./rastreo";
export * from "./manifiestorad";
export * from "./facturaciononline";
export * from "./descripcionespaquetes";
export * from "./matriztarifa";
export * from "./depositobanco";
export * from "./matriztiempos";
export * from "./diarioventa";
export * from "./antiguedadsaldos";
export * from "./tarifapagochofer";
export * from "./zonaextendida";
export * from "./correocontactocontroller";
export * from "./usuarioze";
export * from "./choferze";
export * from "./corteingresosze";
export * from "./entregaingresosZE";
export * from "./cargaze";
export * from "./resumenchoferze";
export * from "./rep";
export * from "./guiasenviadasrecibidas";
export * from "./seguimientoventas";
export * from "./estadisticasclientes";
export * from "./envioscanalcomercializacion";
export * from "./eficienciaead";
export * from "./tarifapp";
export * from "./paquetespp";
export * from "./cobranza2";
export * from "./viajeze";
export * from "./viajezeapp";
export * from "./entregazerealizada";
export * from "./liberacionentregaze";
export * from "./descargaze";
export * from "./saldousuariosze";
export * from "./consultaguiassucursalze";
export * from "./reportecomportamientocomercial";
export * from "./reportelibroadministracion";
export * from "./repguiasdoc";
export * from "./repsaldoscart";
export * from "./partidaaclaracion";
export * from "./reportepartidasaclaracion";
export * from "./choferead";
export * from "./choferruta";
export * from "./direccioncliente";
export * from "./clientedescripcionespaquetes";
export * from "./clientedecliente";
export * from "./reporteconsultaguias";
export * from "./usuarioapi";
export * from "./bitacoraRAD";

export * from "./DireccionMunicipio";
export * from "./DireccionCiudad";


// WEBPACK FOOTER //
// ./app/resources/items/index.ts